// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-information__container{
    margin-top: calc( var(--space-half-quarter) + var(--space-eighth) );
    padding: 15px 18px;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    border-radius: calc( var(--space-half-quarter) + var(--space-eighth) );
}
.tournament-information span{
    margin-right: var( --space-half-quarter );
    font-size: calc( var(--space-half-quarter) + var(--space-eighth) );
}
.tournament-information .hubicon-participants{
    font-size: var( --space-half-quarter );
    margin-right: 10px;
}
.tournament-information-title.baloa-names{
    color: var(--primary-dark-color);
    margin-bottom: var(--space);
}

.tournament-information__detail{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: calc( var(--space-half-quarter) + var(--space-eighth) );
    line-height: var(--space);
    letter-spacing: 0.0025em;
    color: var(--primary-dark-color);
    margin-bottom: 10px;
    display: flex;
}
.tournament-information__detail__subTitle.baloa-table-column{
    color: var(--primary-dark-color);
    margin-bottom: 10px;
}
.tournament-information__detail__text.baloa-username{
    color: var(--primary-dark-color);
    margin-bottom: 20px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .tournament-information__container{
        margin: var(--space);
    }
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/tournament-information/TournamentInformationComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,mEAAmE;IACnE,kBAAkB;IAClB,8BAA8B;IAC9B,iDAAiD;IACjD,sEAAsE;AAC1E;AACA;IACI,yCAAyC;IACzC,kEAAkE;AACtE;AACA;IACI,sCAAsC;IACtC,kBAAkB;AACtB;AACA;IACI,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,kEAAkE;IAClE,yBAAyB;IACzB,wBAAwB;IACxB,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,oBAAoB;IACxB;AACJ","sourcesContent":[".tournament-information__container{\n    margin-top: calc( var(--space-half-quarter) + var(--space-eighth) );\n    padding: 15px 18px;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    border-radius: calc( var(--space-half-quarter) + var(--space-eighth) );\n}\n.tournament-information span{\n    margin-right: var( --space-half-quarter );\n    font-size: calc( var(--space-half-quarter) + var(--space-eighth) );\n}\n.tournament-information .hubicon-participants{\n    font-size: var( --space-half-quarter );\n    margin-right: 10px;\n}\n.tournament-information-title.baloa-names{\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space);\n}\n\n.tournament-information__detail{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: calc( var(--space-half-quarter) + var(--space-eighth) );\n    line-height: var(--space);\n    letter-spacing: 0.0025em;\n    color: var(--primary-dark-color);\n    margin-bottom: 10px;\n    display: flex;\n}\n.tournament-information__detail__subTitle.baloa-table-column{\n    color: var(--primary-dark-color);\n    margin-bottom: 10px;\n}\n.tournament-information__detail__text.baloa-username{\n    color: var(--primary-dark-color);\n    margin-bottom: 20px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .tournament-information__container{\n        margin: var(--space);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
